@let transitions = transitionsResource.value();
@if (transitions) {
  <unity-workflow-selector-shared flow="horizontal" [disabled]="false" [transitions]="transitions" (workflowEvent)="doTransition($event)" />
}
